module.exports = __webpack_public_path__ + "images/emoji/thought_balloon.46227f89dcfc3e9d9a71.png";